import React from 'react'
import { Listicle, Richtext } from '@christies/react/components/Editorial'
import { SelectValue, withParsedContext } from '../../withJSSContext'
import { RenderFields } from '../../utils'

type ListType = 'number' | 'bullet' | 'general'

interface Props {
  parsedFields: {
    Title: string
    'Secondary title': string
    Description: string
    'List type': SelectValue<ListType>
    'List width': SelectValue<'6' | '8'>
  }
  parsedRouteFields: {
    'Story Theme': SelectValue<'light' | 'dark'>
  }
}

const MagazinesListItemModule: React.FC<Props> = ({ parsedFields, parsedRouteFields }) => {
  const description = parsedFields?.['Description']
  const mdWidth = parsedFields['List width']?.key
  const theme = parsedRouteFields['Story Theme']?.key

  return (
    <RenderFields parsedFields={parsedFields}>
      <>
        <Listicle
          theme={theme}
          type={parsedFields?.['List type']?.key}
          title={parsedFields?.['Title']}
          secondaryTitle={parsedFields?.['Secondary title']}
          mdWidth={mdWidth}
        />
        {description && <Richtext theme={theme} mdWidth={mdWidth} html={description} />}
      </>
    </RenderFields>
  )
}

export default withParsedContext(MagazinesListItemModule as React.FC)
